import { useState } from 'react'
import { motion } from 'framer-motion'
import { RxEnvelopeClosed } from 'react-icons/rx'
import { useMutation } from '@tanstack/react-query'
import apiClient from 'UpdatedFeatures/apiClient'
import { toast } from 'react-toastify'

export default function ResetPasswordModal({ isOpen, onClose }) {
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState('')
    const [error, setError] = useState('')

    const mutation = useMutation({
        mutationFn: async (email) => {
            try {
                const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/forgot-password`;
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ email })
                });
                
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Error sending forgot password request');
                }
                
                return await response.json();
            } catch (error) {
                throw new Error(error.message || 'Error sending forgot password request');
            }
        },
        onSuccess: () => {
            toast('Veuillez vérifier votre e-mail pour le lien de réinitialisation.')
            setError('')
            setEmail('')
            onClose()
        },
        onError: (err) => {
            console.log(err);
            const msg = err.message || 'Quelque chose a mal tourné. Veuillez réessayer.';
            if (msg.toLowerCase().includes("email")) {
                setError("Adresse Email Invalide");
            } else {
                setError(msg);
            }
            setMessage('');
        },
    })

    const handleSubmit = (e) => {
        e.preventDefault()
        mutation.mutate(email)
    }

    if (!isOpen) return null

    return (
        <motion.div
            className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500/75"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={onClose}
        >
            <motion.div
                className="relative transform overflow-hidden rounded-lg mx-5 bg-white text-left shadow-xl sm:w-full sm:max-w-lg"
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 50, opacity: 0 }}
                transition={{ duration: 0.3 }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="bg-white px-4 pt-4 pb-3 sm:p-5 sm:pb-3">
                    <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex size-10 shrink-0 items-center justify-center rounded-full bg-yellow-100 sm:mx-0 sm:size-12 p-3">
                            <RxEnvelopeClosed className="size-8 text-[#f2c02a] " aria-hidden="true" />
                        </div>
                        <div className="mt-2 sm:mt-0 sm:ml-3 text-left">
                            <h3 className="text-2xl font-semibold text-gray-900">
                                Réinitialisation du mot de passe
                            </h3>
                            <p className="mt-1 text-sm text-gray-600">
                                Veuillez entrer votre adresse e-mail pour recevoir un lien de réinitialisation.
                            </p>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="mt-2 w-full rounded-md border-gray-300 px-3 py-1.5 text-gray-900 shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm"
                                placeholder="Votre adresse e-mail"
                            />
                        </div>
                    </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse gap-4 sm:px-5">
                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={mutation.isPending}
                        className="inline-flex w-full justify-center rounded-md bg-[#f2c02a] px-4 py-1.5 text-sm font-semibold text-white ring-1 shadow-sm ring-gray-300 ring-inset hover:bg-[#f2c02ad0] sm:w-auto"
                    >
                        {mutation.isPending ? 'Envoi...' : 'Envoyer'}
                    </button>
                    <button
                        type="button"
                        onClick={onClose}
                        className="inline-flex w-full justify-center rounded-md bg-white px-4 py-1.5 text-sm font-semibold text-gray-900 ring-1 shadow-sm ring-gray-300 ring-inset hover:bg-gray-50 sm:w-auto"
                    >
                        Annuler
                    </button>
                </div>
                {message && (
                    <div className="text-center text-sm font-semibold text-green-600">
                        {message}
                    </div>
                )}
                {error && (
                    <div className="text-center text-sm font-semibold text-red-600 mb-3">
                        {error}
                    </div>
                )}

            </motion.div>
        </motion.div>
    )
}
